import { Container, Heading, Hero, Level } from 'react-bulma-components';

import IsAdmin from 'containers/isadmin';
import { LevelIndicator } from '../components';
import React from 'react';

export default function PageTitle({ name, description, isSong, levelIndicator, color, adminbuttons, bookmarkButton}) {
  let bgColor = color === undefined ? "primary" : color;
  return (
    <Hero className="welcome" color={bgColor} size="small" >
      <Hero.Body>
        <Level renderAs="nav">
          <Level.Side align="left">
            <Container>
              {isSong && <Heading subtitle size={6}>Chord changes similar to</Heading>}
              <Heading>
                {name}
              </Heading>
              <Heading subtitle size={5}>
                {description}
              </Heading>
            </Container>
          </Level.Side>
          <Level.Side align="right" >
            <Container>
            <Level.Item>
              {bookmarkButton}
            </Level.Item>
            <Level.Item>
              <IsAdmin>
            {adminbuttons && adminbuttons.map((button, i) =>
                <b key={i}>{button}</b>
              )}
              </IsAdmin>
              </Level.Item>
            <Level.Item>
              {isSong && <LevelIndicator level={levelIndicator.level} max={levelIndicator.max}/>}
            </Level.Item>
            </Container>
          </Level.Side>
        </Level>
      </Hero.Body>
    </Hero>
  );
}